<template>
  <el-dialog
    title="选择商家"
    width="520px"
    :visible.sync="dialogMerchant.isShow"
    append-to-body
    @open='open'
  >
    <el-form :inline="true" @submit.native.prevent>      
      <el-form-item >
        <el-input  placeholder="商家名称" size="medium" @keyup.enter.native="Search" v-model="name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" v-on:click="Search" >查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="rows" style="width: 100%">
      <el-table-column  prop="Name" :show-overflow-tooltip="true" label="名称"> </el-table-column>
      <el-table-column  fixed="right" width="70px" label="操作" >
        <template slot-scope="scope">
          <el-button @click.native.prevent="Select(scope.row)" type="text" size="small">
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="5"
      :total="totalCount">
    </el-pagination>
  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   import { Loading } from 'element-ui';
   export default {
    props:{
      dialogMerchant:{        
      }
    },
    data(){
      return {
        name:'',
        pageIndex:1,
        pagesize:5,
        totalCount:0,
        sort:' id desc',
        rows:[],
        loading:false
      }
    },
    mounted(){
      
    },
    methods:{
      open:function(){
        this.GetData()
      },
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Merchant/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.rows = resp.data.merchants
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.pageIndex = val 
        this.GetData()
      },
      Select(row){ 
        this.$emit('UpdateMerchant',row.Id,row.Name)
        this.dialogMerchant.isShow = false
      }

    }
   }
</script>
